import Loader from "../Loader";
import "./FullLoader.css"
const FullLoader = ({width="1rem"}) => <div className="FullLoader">
    <Loader width={width} />
</div>

export default FullLoader